import { Box, Button } from "@mui/material";
import LoginForm from "./LoginForm";
import {LEGACY_URL} from "@/utils/api/Urls.ts";
// import SocialLogin from "./SocialLogin";

const Login = ({goToLoginCheckout, setCheckoutData} : {setCheckoutData: () => void, goToLoginCheckout: () => void}) => {
    return (
    <>
      <LoginForm goToLoginCheckout={goToLoginCheckout} setCheckoutData={setCheckoutData}/>
      {/*<SocialLogin />*/}
      <Box display="flex" justifyContent="center">
          <a href={`${LEGACY_URL}/en/Account/PassReset`}>
              <Button variant="text">Forgot your password?</Button>
          </a>
      </Box>
    </>
  );
};

export default Login;
